import { ComputingOption } from "@/service/models/request/computation/computing-option";
import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { RepositoryPercentiles } from "@/utilities/graphing/data-repository/percentiles";
import { DataRepository } from "@/utilities/graphing/data-repository/repository";
import { staticImplements } from "@/utilities/static-implements";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { Percentile } from "./parts/percentile";
import { DataResponse } from "./data-response";

@staticImplements<ResponseModelInterfaceStatic>()
export class DataPercentiles implements DataResponse
{
    public constructor(
        public percentiles: Percentile[],
    )
    {
    }

    /**
     * @inheritdoc
     */
    public static makeFromXml(elem: XmlElementWrapper): DataPercentiles
    {
        return new this(
            elem.mapForEachChildTag("percentile", (subElem) => Percentile.makeFromXml(subElem))
        );
    }

    /**
     * @inheritdoc
     */
    public fillDataRepository(
        dataLoadingState: DataRepository,
        computingParamType: ComputingOption.ParametersType
    ): void
    {
        const percentilesContainer = this.getRepositoryPercentiles(dataLoadingState, computingParamType);

        // Do nothing if the ParametersType is unknown
        if (percentilesContainer === null) {
            return;
        }

        for (const percentile of this.percentiles) {
            percentile.pushInDataRepository(percentilesContainer);
        }
    }

    /**
     * @inheritdoc
     */
    public fillGraphDataAdjustmentsRepository(dataRepository: DataRepository): void
    {
        for (const percentile of this.percentiles) {
            percentile.pushInDataRepository(dataRepository.selectedAdjustmentPercentileData);
        }
    }

    protected getRepositoryPercentiles(
        dataRepository: DataRepository,
        computingParamType: ComputingOption.ParametersType
    ): RepositoryPercentiles|null
    {
        switch (computingParamType) {
            case ComputingOption.ParametersType.APRIORI:
                return dataRepository.aprioriPercentileData;

            case ComputingOption.ParametersType.APOSTERIORI:
                return dataRepository.aposterioriPercentileData;

            case ComputingOption.ParametersType.POPULATION:
                return dataRepository.populationPercentileData;

            default:
                return null;
        }
    }
}
